var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b236b4f2-4a17-4972-b7d6-fc285796cd1e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ab7d5b90-f3d9-4825-a0a1-b2e2e4dc5d14{fill:none;stroke:#eff0f2;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ab7d5b90-f3d9-4825-a0a1-b2e2e4dc5d14",
    d: "M11 1v4m0 12v4M3.93 3.93l2.83 2.83m8.48 8.48l2.83 2.83M1 11h4m12 0h4M3.93 18.07l2.83-2.83m8.48-8.48l2.83-2.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.8446109ce92712d0d012d45805a4cdaa.svg";
export { ForwardRef as ReactComponent };